/* V2 — Universal preloader for quick-add popup images. Covers all
   three quick-add surfaces (home rows, collection page cards, cart
   upsell cards) so the popup hero image is in the browser cache by
   the time the user opens the drawer. Without this, the drawer
   showed a blank panel or the PREVIOUS product's image for 0.5–2s
   while the new image loaded. */
(function () {
  if (window.__neswQAPreloadInit) return;
  window.__neswQAPreloadInit = true;

  var preloaded = Object.create(null);
  function preload(url) {
    if (!url || preloaded[url]) return;
    preloaded[url] = true;
    var img = new Image();
    img.src = url;
  }

  /* Collect every image URL that this card might display in any
     popup. Includes the default product image + every swatch's
     variant image so swapping color mid-flow stays instant. */
  function collectUrls(triggerEl) {
    var urls = [];
    if (!triggerEl) return urls;

    /* Home rows / collection cards: trigger is `.quick-add-btn`
       inside a `.quick-add-wrapper`. */
    var wrap = triggerEl.closest('.quick-add-wrapper');
    if (wrap) {
      if (wrap.dataset.selectedColorImage) urls.push(wrap.dataset.selectedColorImage);
      if (triggerEl.dataset && triggerEl.dataset.productImage) urls.push(triggerEl.dataset.productImage);
      var card = triggerEl.closest('.collection-item, .nesw-row__card-wrap');
      if (card) {
        card.querySelectorAll('.color-swatch, .product-color-swatch').forEach(function (sw) {
          if (sw.dataset.variantImage) urls.push(sw.dataset.variantImage);
          if (sw.dataset.image) urls.push(sw.dataset.image);
        });
      }
    }

    /* Cart upsell cards: trigger is `.related-quick-add-btn`. */
    var rcCard = triggerEl.closest('.product-recommendations-card');
    if (rcCard) {
      var primary = rcCard.querySelector('.related-product-img-primary');
      if (primary && (primary.currentSrc || primary.src)) urls.push(primary.currentSrc || primary.src);
      rcCard.querySelectorAll('.related-color-swatch').forEach(function (sw) {
        if (sw.dataset.image) urls.push(sw.dataset.image);
      });
    }
    return urls;
  }

  function preloadFromTrigger(triggerEl) {
    collectUrls(triggerEl).forEach(preload);
  }

  /* Desktop: hover preload. Capture phase so we beat any handler
     that stops propagation downstream. */
  document.addEventListener('mouseenter', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.nesw-row .quick-add-btn, .quick-add-btn, .related-quick-add-btn');
    if (!btn) return;
    preloadFromTrigger(btn);
  }, true);

  /* Mobile: touchstart preload — fires ~100–200ms before the
     synthetic click on tap, giving the network a head start. */
  document.addEventListener('touchstart', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.nesw-row .quick-add-btn, .quick-add-btn, .related-quick-add-btn');
    if (!btn) return;
    preloadFromTrigger(btn);
  }, { passive: true, capture: true });

  /* IntersectionObserver: opportunistic preload as cards approach the
     viewport. 400px rootMargin gives the network plenty of lead time
     before the user can scroll the bag icon into the tappable area. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        preloadFromTrigger(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '400px 0px 400px 0px' });
    function observeAll() {
      document.querySelectorAll(
        '.nesw-row .quick-add-btn, .quick-add-btn, .related-quick-add-btn'
      ).forEach(function (btn) {
        if (btn.__neswQAPreloadObserved) return;
        btn.__neswQAPreloadObserved = true;
        io.observe(btn);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll, { once: true });
    } else {
      observeAll();
    }
    /* Cards in the cart drawer are JS-rendered after open — re-observe
       on cart:change. Same for sort/filter on collection pages. */
    document.addEventListener('cart:change', observeAll);
  }
})();

(function () {
  if (window.__neswQadDrawerBound) return;
  window.__neswQadDrawerBound = true;

  var drawer = document.getElementById('nesw-qad-drawer');
  /* Pack-chip proxy state: the button/card the sheet was last populated
     from, so a proxy tap can re-populate after the card chip runs. */
  var __qadLastBtn = null;
  var __qadLastCard = null;
  if (!drawer) return;
  var sizesEl = drawer.querySelector('[data-qad-sizes]');
  var imgEl = drawer.querySelector('[data-qad-image]');
  var titleEl = drawer.querySelector('[data-qad-title]');
  var priceEl = drawer.querySelector('[data-qad-price]');

  function isMobile() { return window.innerWidth <= 768; }
  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* Proxy chip taps: click the REAL card chip (swap/extra logic lives
     there), then re-populate the sheet from the — possibly swapped —
     quick-add button. Re-resolve the button from the card: a tank swap
     rewrites its dataset in place, so the reference stays valid, but
     resolving defensively costs nothing. */
  if (drawer) drawer.addEventListener('click', function (e) {
    var px = e.target.closest && e.target.closest('[data-qad-pack-proxy]');
    if (!px) return;
    e.preventDefault();
    e.stopPropagation();
    if (!__qadLastCard) return;
    var ref = (px.getAttribute('data-qad-pack-proxy') || '').split(':');
    var rows = __qadLastCard.querySelectorAll('.nesw-row__packs');
    var rowEl = rows[parseInt(ref[0], 10)];
    var target = rowEl && rowEl.querySelectorAll('.pack-btn')[parseInt(ref[1], 10)];
    if (!target) return;
    target.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    var refreshBtn = __qadLastCard.querySelector('.quick-add-btn') || __qadLastBtn;
    setTimeout(function () { if (refreshBtn) populate(refreshBtn); }, 60);
  });

  function populate(btn) {
    var variants = [];
    try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch (_) {}

    /* Use the selected color (from any swatch in the same product card) to
       filter variants, just like the inline desktop drawer. */
    var pid = btn.dataset.productId;
    var wrap = btn.closest('.quick-add-wrapper');
    var selectedColor = wrap && wrap.dataset.selectedColor;
    /* Initial open: dataset.selectedColor is empty until a swatch is clicked.
       Fall back to the default-active swatch so sold-out sizes reflect the
       shown color (not aggregated across colors → "Add to bag" on a size that's
       sold out in this color, then a cart error). */
    if (!selectedColor) {
      var __qadCard = btn.closest('.collection-item');
      var __qadSwatch = __qadCard && __qadCard.querySelector('.color-swatch.active');
      if (__qadSwatch) selectedColor = (__qadSwatch.dataset.color || '').trim();
    }
    var filtered = variants;
    if (selectedColor) {
      filtered = variants.filter(function (v) { return v.color === selectedColor; });
      if (!filtered.length) filtered = variants;
    }
    /* Extra-axis chips (Pack Size): the sheet must sell the chosen pack.
       Without this the mobile sheet kept offering 3-Pack variants after the
       shopper picked 4-Pack on the card (2026-09-04). */
    var __qadExtra = wrap && wrap.dataset.selectedExtra;
    if (__qadExtra) {
      var __qadPool = filtered.filter(function (v) { return (v.extra || '') === __qadExtra; });
      if (__qadPool.length) filtered = __qadPool;
    }

    /* View-product link — deep-links to the PDP (at the chosen variant when a
       color is pinned) so the shopper can always reach the full product page. */
    var viewEl = drawer.querySelector('[data-qad-view]');
    if (viewEl) {
      var purl = btn.dataset.productUrl || '';
      if (purl) {
        var pickV = null;
        for (var fi = 0; fi < filtered.length; fi++) { if (filtered[fi].available) { pickV = filtered[fi]; break; } }
        if (!pickV && filtered.length) pickV = filtered[0];
        if (selectedColor && pickV && pickV.id) purl += (purl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + pickV.id;
        viewEl.setAttribute('href', purl);
        viewEl.style.display = '';
      } else {
        viewEl.style.display = 'none';
      }
    }

    /* Linked-listings pills — same map the PDP renders, passed via
       data-linked-listings on the card button ('Group>Label*handle,...|...').
       The pill matching THIS product renders inert; others navigate to their
       listing (e.g. tank 3-Pack -> 6-Pack, whose card is hidden from grids). */
    var linkedWrap = drawer.querySelector('[data-qad-linked-wrap]');
    if (linkedWrap) {
      var llEsc = function (s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
          .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      };
      /* Mirror EVERY chip row from the card into the sheet — the swap rows
         (visible pack groups + hidden Weight/Style/Bundle groups) and the
         extra-axis variant chips — as PROXIES. A tap clicks the real card
         chip (all swap/reprice logic stays in nesw-pack-swap.js and the
         card handlers), then the sheet re-populates, so Lightweight/
         Heavyweight and Single/3-Pack flip INSIDE the popup instead of
         navigating (Jay 2026-09-04). */
      var __pxCard = btn.closest('.collection-item, .nesw-row__card-wrap');
      var __pxRows = __pxCard ? __pxCard.querySelectorAll('.nesw-row__packs') : [];
      var llHtml = '';
      __pxRows.forEach(function (rowEl, ri) {
        var chips = rowEl.querySelectorAll('.pack-btn');
        if (chips.length < 2) return;
        var pxRow = '';
        chips.forEach(function (c, ci) {
          pxRow += '<button type="button" class="bundle-btn' + (c.classList.contains('active') ? ' bundle-btn-active' : '') + '" data-qad-pack-proxy="' + ri + ':' + ci + '">' + llEsc(c.textContent.trim()) + '</button>';
        });
        var label = rowEl.getAttribute('aria-label') || rowEl.getAttribute('data-extra-name') || 'Options';
        llHtml += '<div class="nesw-qad-drawer__sizes-label">' + llEsc(label) + '</div>'
               + '<div class="nesw-qad-drawer__linked-row">' + pxRow + '</div>';
      });
      linkedWrap.innerHTML = llHtml;
      linkedWrap.style.display = llHtml ? '' : 'none';
      __qadLastBtn = btn;
      __qadLastCard = __pxCard;
    }

    titleEl.textContent = btn.dataset.productTitle || '';
    /* Sale-aware: render struck pre-sale + sale price when on sale (nesw-sale-price
       markup passed via data-product-price-html), else plain price. */
    if (btn.dataset.productPriceHtml) { priceEl.innerHTML = btn.dataset.productPriceHtml; }
    else { priceEl.textContent = btn.dataset.productPrice || ''; }
    /* V2 — Per Jay: prefer the swatch's stored variant image so picking
       a secondary color on the card and opening the drawer shows that
       color's photo. Falls back to the product's default image when
       no swatch has been picked yet.

       Wrap the swap in a `<img>` opacity transition so the PREVIOUS
       product's still-cached raster doesn't flash through while the
       new url fetches. If the new image was preloaded on hover /
       touchstart / IntersectionObserver, `complete + naturalWidth`
       is truthy synchronously and the opacity flips back in the same
       frame — no visible transition. If it's a cache miss, the
       image fades in cleanly once it lands. */
    var __newSrc = (wrap && wrap.dataset.selectedColorImage) || btn.dataset.productImage || '';
    imgEl.style.transition = 'opacity 0.12s ease';
    imgEl.style.opacity = '0';
    function __qadReveal() { imgEl.style.opacity = '1'; }
    imgEl.onload = __qadReveal;
    imgEl.onerror = __qadReveal;
    imgEl.src = __newSrc;
    imgEl.alt = btn.dataset.productTitle || '';
    if (imgEl.complete && imgEl.naturalWidth > 0) __qadReveal();

    /* Render the size rows for a given active color. Extracted into a function
       so the in-drawer color picker (below) can re-render on a color change.
       When no color is active we aggregate availability across colors so a
       size shows in-stock if ANY color has it. Single-size products (e.g. hats
       = "One Size") skip the size list and show one plain "Add to bag". */
    var sizesLabelEl = drawer.querySelector('[data-qad-sizes-label]');
    function renderQadSizes(activeColor) {
      while (sizesEl.firstChild) sizesEl.removeChild(sizesEl.firstChild);
      var fil = activeColor ? variants.filter(function (v) { return v.color === activeColor; }) : variants;
      if (activeColor && !fil.length) fil = variants;
      /* Extra-axis chips (Pack Size): the ROWS must sell the chosen pack —
         `filtered` above feeds pickV/deep-link, but this list builds the add
         rows and was missing the filter, so the sheet added 3-Pack variants
         after a 4-Pack pick (2026-09-04). */
      if (__qadExtra) {
        var __qadRowPool = fil.filter(function (v) { return (v.extra || '') === __qadExtra; });
        if (__qadRowPool.length) fil = __qadRowPool;
      }
      var uSizes = [];
      fil.forEach(function (v) { if (uSizes.indexOf(v.size) < 0) uSizes.push(v.size); });

      /* One size (or no real size option): a single Add-to-bag, no "Select size". */
      if (uSizes.length <= 1) {
        if (sizesLabelEl) sizesLabelEl.style.display = 'none';
        var only = null;
        for (var oi = 0; oi < fil.length; oi++) { if (fil[oi].available) { only = fil[oi]; break; } }
        if (!only && fil.length) only = fil[0];
        var single = document.createElement('div');
        single.className = 'nesw-qad-row nesw-qad-row--single';
        if (only && only.available) {
          var addOne = document.createElement('button');
          addOne.type = 'button';
          addOne.className = 'nesw-qad-row__add';
          addOne.dataset.variantId = String(only.id);
          addOne.dataset.size = only.size || '';
          addOne.dataset.productId = pid || '';
          addOne.textContent = 'Add to bag';
          addOne.style.width = '100%';
          single.appendChild(addOne);
        } else {
          var soldOne = document.createElement('span');
          soldOne.className = 'nesw-qad-sold';
          soldOne.textContent = 'Sold out';
          single.appendChild(soldOne);
        }
        sizesEl.appendChild(single);
        return;
      }

      if (sizesLabelEl) sizesLabelEl.style.display = '';
      var aggregateAvail = Object.create(null);
      if (!activeColor) { variants.forEach(function (v) { if (v.available) aggregateAvail[v.size] = true; }); }
      var seen = Object.create(null);
      fil.forEach(function (v) {
        if (seen[v.size]) return;
        seen[v.size] = true;
        var inStock = activeColor ? !!v.available : !!aggregateAvail[v.size];
        var row = document.createElement('div');
        row.className = 'nesw-qad-row';
        var name = document.createElement('span');
        name.className = 'nesw-qad-row__name' + (inStock ? '' : ' nesw-qad-row__name--oos');
        name.textContent = v.size;
        row.appendChild(name);
        if (inStock) {
          var add = document.createElement('button');
          add.type = 'button';
          add.className = 'nesw-qad-row__add';
          add.dataset.variantId = String(v.id);
          add.dataset.size = v.size;
          add.dataset.productId = pid || '';
          add.textContent = 'Add to bag';
          row.appendChild(add);
        } else {
          /* V2 — Clean "SOLD OUT" chip instead of a disabled button (cuq). */
          var sold = document.createElement('span');
          sold.className = 'nesw-qad-sold';
          sold.textContent = 'Sold out';
          row.appendChild(sold);
        }
        sizesEl.appendChild(row);
      });
    }

    /* In-drawer color picker — only where there's NO external swatch (the
       product collage). Collection/related cards already have swatches on the
       card that set data-selectedColor, so we leave those drawers unchanged. */
    var colorsEl = drawer.querySelector('[data-qad-colors]');
    var colorsWrap = drawer.querySelector('[data-qad-colors-wrap]');
    var allColors = [];
    variants.forEach(function (v) { if (v.color && allColors.indexOf(v.color) < 0) allColors.push(v.color); });
    var extCard = btn.closest('.collection-item');
    var hasExtSwatch = extCard && extCard.querySelector('.color-swatch, .product-color-swatch');
    var showDrawerColors = allColors.length > 1 && !hasExtSwatch && colorsEl && colorsWrap;
    var activeColor = selectedColor || null;

    if (showDrawerColors) {
      /* V2 — Per-color hero image swap (Jay 2026-07-12): the in-drawer color
         picker used to re-render the SIZES only, leaving the previous color's
         photo up. The overlay now ships a { color: imageUrl } map in
         data-color-images; swap with the same fade pattern as the initial
         load. Fail-open: colors with no mapped image keep the current photo. */
      var colorImgs = {};
      try { colorImgs = JSON.parse(btn.dataset.colorImages || '{}'); } catch (_) {}
      function swapQadImage(color) {
        var src = colorImgs[color];
        if (!src || imgEl.src === src) return;
        imgEl.style.transition = 'opacity 0.12s ease';
        imgEl.style.opacity = '0';
        function reveal() { imgEl.style.opacity = '1'; }
        imgEl.onload = reveal;
        imgEl.onerror = reveal;
        imgEl.src = src;
        if (imgEl.complete && imgEl.naturalWidth > 0) reveal();
      }
      if (!activeColor || allColors.indexOf(activeColor) < 0) {
        activeColor = null;
        for (var ci = 0; ci < allColors.length; ci++) {
          if (variants.some(function (v) { return v.color === allColors[ci] && v.available; })) { activeColor = allColors[ci]; break; }
        }
        if (!activeColor) activeColor = allColors[0];
      }
      colorsEl.innerHTML = allColors.map(function (c) {
        var avail = variants.some(function (v) { return v.color === c && v.available; });
        return '<button type="button" class="nesw-qad-color' + (c === activeColor ? ' is-on' : '') + (avail ? '' : ' is-out') +
          '" data-qc="' + c + '"' + (avail ? '' : ' disabled') + '>' + c + '</button>';
      }).join('');
      colorsWrap.style.display = '';
      colorsEl.querySelectorAll('[data-qc]').forEach(function (cb) {
        cb.addEventListener('click', function () {
          if (cb.classList.contains('is-out')) return;
          activeColor = cb.dataset.qc;
          colorsEl.querySelectorAll('[data-qc]').forEach(function (x) { x.classList.remove('is-on'); });
          cb.classList.add('is-on');
          renderQadSizes(activeColor);
          swapQadImage(activeColor);
        });
      });
      renderQadSizes(activeColor);
      swapQadImage(activeColor);
    } else {
      if (colorsWrap) colorsWrap.style.display = 'none';
      renderQadSizes(selectedColor);
    }
  }

  /* V2 — Open this drawer for ANY `.quick-add-btn` on the page, not
     just the home rows. The collection pages and the PDP Best Sellers
     row all use the same `.quick-add-btn` class with the same data
     attributes (`data-product-id/title/price/image/variants` + the
     wrapper's `data-selected-color/selectedColorImage`), so this
     single popup can serve every surface — guaranteeing the look and
     feel are identical site-wide. Capture phase + `stopImmediate-
     Propagation()` blocks the collection-page sections' own
     popup-opener handlers from firing a second drawer. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quick-add-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    populate(btn);
    open();
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-qad-close]')) {
      e.preventDefault(); e.stopPropagation(); close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  function setAdded(btn) {
    btn.classList.add('nesw-qad-row__add--added');
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '3');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var poly = document.createElementNS(svgNS, 'polyline');
    poly.setAttribute('points', '20 6 9 17 4 12');
    svg.appendChild(poly);
    btn.appendChild(svg);
    var lbl = document.createElement('span');
    lbl.textContent = 'Added';
    btn.appendChild(lbl);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.nesw-qad-row__add');
    if (!add || add.disabled) return;
    e.preventDefault(); e.stopPropagation();
    var vid = add.dataset.variantId;
    if (!vid) return;
    var original = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding…';
    /* Canonical add (fires Meta AddToCart + reconciles /cart.js + cart:change). */
    window.neswAddToCart(vid, 1)
      .then(function () {
        setAdded(add);
        /* 🔴 Refresh the cart NOW (not after the 700ms feedback delay): the
           patched window.updateCart re-fetches /cart.js, repaints the header
           badge, and marks the drawer SSR stale so openCartDrawer re-fetches
           fresh. Without an immediate refresh the badge/drawer showed the
           pre-add cart until a page reload (Jay: "adds on refresh"). */
        window.__neswScrollCartTopAfterUpdate = true;
        if (typeof window.updateCart === 'function') window.updateCart();
        else if (typeof window.updateCartCount === 'function') window.updateCartCount();
        setTimeout(function () {
          close();
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        }, 700);
      })
      .catch(function () {
        add.textContent = 'Error';
        setTimeout(function () { add.disabled = false; add.textContent = original; }, 1600);
      });
  });
})();
